module.exports = __webpack_public_path__ + "media/images/illustrations/happiness-63381f6a4557ce7dbabe02709590e59e.svg";